import { GET_INFO_APPLY_ERROR, GET_INFO_APPLY_START, GET_INFO_APPLY_SUCCESS } from '../../types';

export default function get_info_apply(state, action) {
  switch (action.type) {
    case GET_INFO_APPLY_START:
      return { ...state };
    case GET_INFO_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_INFO_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
